// -- [Shared Radix Select trigger styles for hero + sticky]

export type SelectTriggerTone = 'onBrand' | 'light'

const TONE_CLASS: Record<SelectTriggerTone, string> = {
  onBrand:
    'rounded-lg bg-white/95 backdrop-blur px-4 py-3 text-gray-900 font-medium shadow-md border border-white/80 hover:bg-white hover:shadow-lg hover:scale-[1.02] focus-visible:ring-white',
  light:
    'rounded-lg border-2 border-gray-300 bg-white px-3 py-2.5 text-sm font-medium text-gray-900 hover:border-brand-orange hover:bg-brand-orange/5 focus-visible:ring-brand-orange',
}

/** -- Class string for Select.Trigger */
export function selectTriggerClass(
  tone: SelectTriggerTone = 'light',
  className = ''
): string {
  return `inline-flex items-center justify-between gap-2 min-h-12 transition-all cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${TONE_CLASS[tone]} ${className}`
}

export const selectItemClass =
  'px-4 py-2 cursor-pointer outline-none hover:bg-brand-orange/20 data-[highlighted]:bg-brand-orange/20 text-gray-900'

export const selectContentClass =
  'bg-white rounded-lg shadow-lg overflow-hidden z-[100] border border-line'
